/*
 * --------------------------------------------------------------------------- *
 * File: textfield.js                                                          *
 * Project: web                                                                *
 * Created Date: 29 Oct 2022                                                   *
 * Author: Vikas K Solegaonkar (vikas.solegaonkar@gmail.com)                   *
 * Copyright (c) 2022 Vikas K Solegaonkar                                      *
 * https://solegaonkar.com                                                     *
 *                                                                             *
 * Last Modified: Mon Nov 07 2022                                              *
 * Modified By: Vikas K Solegaonkar                                            *
 *                                                                             *
 * HISTORY:                                                                    *
 * --------------------------------------------------------------------------- *
 * Date         By     Comments                                                *
 * --------------------------------------------------------------------------- *
 */

import React, { useContext, useEffect } from "react";
import "../App.css";
import { AppContext } from "../main/context";
import { replaceMicrosoftCharacters } from "../main/utilities";

function TextField(props) {
  const { flashRequired, allowNextRef, forceRefresh } = useContext(AppContext);

  useEffect(() => {
    if (props.type.required && !props.value && allowNextRef.current) {
      allowNextRef.current = false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [forceRefresh]);

  const onChange = (e) => {
    if (props.type.fieldType === "password") {
    } else if (props.type.fieldType === "text") {
      e = replaceMicrosoftCharacters(e);
    }
    if (props && props.onChange) {
      props.onChange(e);
    }
  };

  return (
    <div className={props.type.divCss}>
      <div className="field-title">
        {props.type.fieldTitle}
        {props.type.required ? "*" : ""}
      </div>
      <input
        type={props.type.fieldType}
        value={props.value}
        className={props.type.required && flashRequired && !props.value ? "wide required" : "wide"}
        onChange={(e) => onChange(e.target.value)}
        readOnly={props.type.readOnly}
      ></input>
    </div>
  );
}

export default TextField;
